import { render, staticRenderFns } from "./AMEI_Vision.vue?vue&type=template&id=55df8d20&scoped=true"
import script from "./AMEI_Vision.vue?vue&type=script&lang=js"
export * from "./AMEI_Vision.vue?vue&type=script&lang=js"
import style0 from "./AMEI_Vision.vue?vue&type=style&index=0&id=55df8d20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55df8d20",
  null
  
)

export default component.exports